import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Switch, Route } from "react-router";
import HomeContainer from "../components/Home";
import LoginContainer from "../components/Auth/Login";
import RegisterContainer from "../components/Auth/Register";
import LogoutContainer from "../components/Auth/Logout";
import ResetPassword from "../components/Auth/ResetPassword";
import UsersContainer from "../components/User";
import InvitesContainer from "components/Invites";
import SecurityContainer from "components/security";
import SettingsContainer from "components/settings";
import { AppRouteURI } from "./RoleBasedAccess";
import PropTypes from "prop-types";
import LandingPage from "components/LandingPage";

function AppRouter({ history }) {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path={AppRouteURI.LANDING} component={LandingPage} />
        <Route exact path={AppRouteURI.HOME} component={HomeContainer} />
        <Route path={AppRouteURI.LOGIN} component={LoginContainer} />
        <Route path={AppRouteURI.LOGOUT} component={LogoutContainer} />
        <Route path={AppRouteURI.REGISTER} component={RegisterContainer} />
        <Route path={AppRouteURI.INVITATION} component={RegisterContainer} />
        <Route path={AppRouteURI.MEMBERS} component={UsersContainer} />
        <Route path={AppRouteURI.SECURITY} component={SecurityContainer} />
        <Route path={AppRouteURI.SETTINGS} component={SettingsContainer} />
        <Route path={AppRouteURI.INVITES} component={InvitesContainer} />
        <Route path={AppRouteURI.RESET_PWD} component={ResetPassword} />
      </Switch>
    </ConnectedRouter>
  );
}
AppRouter.prototypes = {
  history: PropTypes.object.isRequired,
};
export default AppRouter;
